import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

@observer
export class ButterBar extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    handleCloseClick: PropTypes.func,
    title: PropTypes.string,
    message: PropTypes.string,
    inline: PropTypes.bool,
    formColClass: PropTypes.string,
    type: PropTypes.string,
    autoFocus: PropTypes.bool
  };

  static defaultProps = {
    type: 'error',
    title: '',
    message: '',
    formColClass: '',
    autoFocus: false
  }

  componentDidMount() {
    if (this.props.autoFocus) { this.alertRef.focus() }
  }

  renderAlert = () => {
    if (!this.props.message) {
      return '';
    }
    const messageIsTwoParts = this.props.title && this.props.message;
    const mainMessage = messageIsTwoParts ? this.props.title : this.props.message;
    const details = messageIsTwoParts ? this.props.message : '';
    return (<div className={`alert alert-${this.props.type}`} tabIndex={-1} ref={(i) => { this.alertRef = i }}>
      <button type="button" className="close_btn icon-close" onClick={this.props.handleCloseClick}>
        <span className="sr-only">Close alert</span>
      </button>
      <p dangerouslySetInnerHTML={{
          __html: mainMessage
        }}></p>
      {details
        ? <p className="alert-details" dangerouslySetInnerHTML={{
            __html: details
          }}></p>
        : ''}
    </div>)
  }

  render() {
    return (<div className={`alert-bars ${this.props.formColClass}`}>
      {/* Screen reader section should always be present, not conditionally
        rendered, to allow aria to manage changes appropriately. */
      }
      <p className="sr-only" role="alert" aria-live="assertive" aria-atomic="true">
        {this.props.title ? this.props.title + '. ' : ''}&nbsp;{this.props.message}
      </p>
      {this.renderAlert()}
    </div>)
  }
}
